export default {
  mapArray (items: [], defaultLanguage: string, fallbackLanguage: string) {
    return items.map(item => {
      return this.copyProps(item, {}, defaultLanguage, fallbackLanguage)
    })
  },
  mapObject (item: any, defaultLanguage: string, fallbackLanguage: string) {
    return this.copyProps(item, {}, defaultLanguage, fallbackLanguage)
  },
  copyProps (src: any, dst: any, defaultLanguage: string, fallbackLanguage: string) {
    Object.keys(src).forEach(propName => {
      if (propName === 'translates') {
        let translates = src[propName]
        let translate = {}
        let defaultLanguageTranslates = translates.filter((trans: any) => {
          return trans.language === defaultLanguage
        })

        let fallbackLanguageTranslates = translates.filter((trans: any) => {
          return trans.language === fallbackLanguage
        })

        if (defaultLanguageTranslates.length > 0) {
          translate = defaultLanguageTranslates[0]
        } else if (fallbackLanguageTranslates.length > 0) {
          translate = fallbackLanguageTranslates[0]
        } else if (translates.length > 0) {
          translate = translates[0]
        }

        this.copyProps(translate, dst, defaultLanguage, fallbackLanguage)
      } else if (propName === 'genres') {
        dst[propName] = []
        src[propName].forEach((genre: any) => {
          let flatGenre = {
            id: 0,
            name: ''
          }
          flatGenre.id = genre.id
          let genreTranslates = genre.items
          let genreTranslate = {}
          let genreDefaultLanguageTranslates = genreTranslates.filter((trans: any) => {
            return trans.language === defaultLanguage
          })

          let genreFallbackLanguageTranslates = genreTranslates.filter((trans: any) => {
            return trans.language === fallbackLanguage
          })

          if (genreDefaultLanguageTranslates.length > 0) {
            genreTranslate = genreDefaultLanguageTranslates[0]
          } else if (genreFallbackLanguageTranslates.length > 0) {
            genreTranslate = genreFallbackLanguageTranslates[0]
          } else if (genreTranslates.length > 0) {
            genreTranslate = genreTranslates[0]
          }

          this.copyProps(genreTranslate, flatGenre, defaultLanguage, fallbackLanguage)

          dst[propName].push(flatGenre)
        })
      } else if (propName === 'collections') {
        dst[propName] = []
        src[propName].forEach((collection: any) => {
          let flatCollection = {
            id: 0,
            name: ''
          }
          flatCollection.id = collection.id
          let collectionTranslates = collection.items
          let collectionTranslate = {}
          let collectionDefaultLanguageTranslates = collectionTranslates.filter((trans: any) => {
            return trans.language === defaultLanguage
          })

          let collectionFallbackLanguageTranslates = collectionTranslates.filter((trans: any) => {
            return trans.language === fallbackLanguage
          })

          if (collectionDefaultLanguageTranslates.length > 0) {
            collectionTranslate = collectionDefaultLanguageTranslates[0]
          } else if (collectionFallbackLanguageTranslates.length > 0) {
            collectionTranslate = collectionFallbackLanguageTranslates[0]
          } else if (collectionTranslates.length > 0) {
            collectionTranslate = collectionTranslates[0]
          }

          this.copyProps(collectionTranslate, flatCollection, defaultLanguage, fallbackLanguage)

          dst[propName].push(flatCollection)
        })
      } else {
        dst[propName] = src[propName]
      }
    })

    return dst
  }
}
